import React, { useEffect, useState, useRef } from "react";
import QRCode from "qrcode.react";
import { useParams } from "react-router-dom";
import "../styles/QRCodeGenerator.css";
import { Link } from "react-router-dom";
import axios from "axios";
import { db } from "../firebase/firebase-config";
import { doc, setDoc, addDoc, collection } from "firebase/firestore";
import html2canvas from "html2canvas";

const QRCodeGenerator = () => {
    const { dogId } = useParams();
    const [shortUrl, setShortUrl] = useState("");
    // eslint-disable-next-line
    const [qrCodeImage, setQrCodeImage] = useState(null);
    const qrCodeRef = useRef(null);
    const originalUrl = `https://tailtrails.netlify.app/dogs/${dogId}`;

    useEffect(() => {
        const saveQRCodeToFirestore = async (url) => {
            try {
                const docRef = doc(db, "dogs", dogId);
                await setDoc(
                    docRef,
                    {
                        qrCodeUrl: url,
                    },
                    { merge: true }
                );
                console.log("QR code URL saved to Firestore");
            } catch (error) {
                console.error("Error saving QR code URL to Firestore:", error);
            }
        };

        const sendEmail = async (url, qrCodeImage) => {
            try {
                if (!qrCodeImage) {
                    console.error("QR code image is undefined or null");
                    return;
                }

                console.log("Sending email with URL:", url);
                console.log("Sending email with QR Code Image:", qrCodeImage);

                const mailRef = collection(db, "mail");
                await addDoc(mailRef, {
                    to: ["tailtrailsupdates@gmail.com"], // Recipient email address
                    message: {
                        subject: "QR Code Generated",
                        text: `A QR code has been generated for the dog with ID: ${dogId}. You can view it here: ${url}`,
                        html: `<p>A QR code has been generated for the dog with ID: ${dogId}. You can view it <a href="${url}">here</a>.</p>`,
                        attachments: [
                            {
                                filename: "qrcode.png",
                                content: qrCodeImage.split("base64,")[1],
                                encoding: "base64",
                            },
                        ],
                    },
                });
                console.log("Email queued for delivery");
            } catch (error) {
                console.error("Error sending email:", error);
            }
        };

        const generateQRCodeImage = () => {
            return new Promise((resolve, reject) => {
                if (qrCodeRef.current) {
                    setTimeout(() => {
                        // Ensure QR code is fully rendered
                        html2canvas(qrCodeRef.current)
                            .then((canvas) => {
                                canvas.toBlob((blob) => {
                                    if (!blob) {
                                        reject("Blob is null");
                                        return;
                                    }
                                    const reader = new FileReader();
                                    reader.onloadend = () => {
                                        const base64data = reader.result;
                                        console.log(
                                            "Generated QR Code Image:",
                                            base64data
                                        );
                                        setQrCodeImage(base64data);
                                        resolve(base64data);
                                    };
                                    reader.onerror = (error) => {
                                        reject(
                                            `Error reading blob as DataURL: ${error}`
                                        );
                                    };
                                    reader.readAsDataURL(blob);
                                }, "image/png");
                            })
                            .catch((error) => {
                                reject(
                                    `Error generating QR code image: ${error}`
                                );
                            });
                    }, 1000); // Delay to ensure QR code is fully rendered
                } else {
                    reject("QR Code ref is null");
                }
            });
        };

        const shortenUrl = async () => {
            try {
                const response = await axios.get(
                    `https://is.gd/create.php?format=json&url=${encodeURIComponent(
                        originalUrl
                    )}`
                );
                const shortUrl = response.data.shorturl;
                console.log("Shortened URL:", shortUrl);
                setShortUrl(shortUrl);
                return shortUrl;
            } catch (error) {
                console.error("Error shortening URL:", error);
                setShortUrl(originalUrl); // Fallback to the original URL if an error occurs
                return originalUrl;
            }
        };

        const processQRCode = async () => {
            try {
                const url = await shortenUrl();
                const qrCodeImage = await generateQRCodeImage();

                if (!url || !qrCodeImage) {
                    throw new Error(
                        "Failed to generate QR code or shorten URL"
                    );
                }

                console.log("Processing QR code with URL:", url);
                console.log("Processing QR code with Image:", qrCodeImage);

                await saveQRCodeToFirestore(url);
                await sendEmail(url, qrCodeImage);
            } catch (error) {
                console.error("Error processing QR code:", error);
            }
        };

        processQRCode();
    }, [originalUrl, dogId]);

    return (
        <div className="QRcodereader">
            <div className="qr-code-wrapper" ref={qrCodeRef}>
                {shortUrl && (
                    <QRCode
                        value={shortUrl}
                        size={512} // Increase the size for simplicity
                        bgColor="white"
                        fgColor="black"
                        level="L" // Lower the error correction level for simplicity
                        includeMargin={true}
                    />
                )}
            </div>
            <p>
                This QR code links to information about your dog.
                <br />
                Attach it to your dog's collar.
                <br />
                This QR code will also show up under you dog's information on
                your dashboard.
            </p>
            <p className="linkDashboard">
                <Link to="/home">Return To Dashboard</Link>
            </p>
        </div>
    );
};

export default QRCodeGenerator;
